import { Box, Button, Text, VStack } from "@chakra-ui/react";

export default function Sidebar({ isOpen }) {
    const NAVBAR_HEIGHT = 65; // adjust based on your navbar height
    const recentProjects = [
        "Project name",
        "Project name",
        "Project name",
    ];

    return (
        <Box
            position="fixed"
            top={`${NAVBAR_HEIGHT}px`}
            left="0"
            height={`calc(100vh - ${NAVBAR_HEIGHT}px)`}
            width="250px"
            bg="white"
            borderRight="1px solid transparent"
            zIndex="900"
            transform={isOpen ? "translateX(0)" : "translateX(-100%)"}
            transition="transform 0.25s ease-out"
            p="20px"
        >
            <VStack align="start" spacing={5}>
                <Button
                    width="100%"
                    bg="#CF008A"         // pink bg
                    color="#FFFFFF"      // white text
                    borderRadius="12px"
                    _hover={{ bg: "#CF008A" }}
                    _active={{ bg: "#CF008A" }}
                >
                    New Project
                </Button>
                <Text
                    mt={4}
                    color="#242424"
                    textTransform="uppercase"
                    // fontFamily="Inter"
                    fontSize="11px"
                    fontStyle="normal"
                    fontWeight="700"
                    lineHeight="16px"
                >
                    Recents
                </Text>

                <VStack align="start" spacing={2} width="100%">
                    {recentProjects.map((project, index) => (
                        <Button
                            key={index}
                            // variant="ghost"
                            justifyContent="flex-start"
                            width="100%"
                            borderRadius="12px"
                            fontSize="sm"
                            color="#4F4F4F"
                            bg="transparent"
                            _hover={{ bg: "transparent" }}
                        >
                            {project}
                        </Button>
                    ))}
                </VStack>
            </VStack>
        </Box >
    );
}
